import Image from "next/image"
import { Fragment } from "react"
import { GridItem, Typography } from "@octopus-energy/coral/atoms"
import { type OfferPerk } from "@/features/subscription/types/offerPerk"

type IconGridItemProps = {
    items: ReadonlyArray<OfferPerk>
}

export function IconGridItems({ items }: IconGridItemProps) {
    const iconGridItems = items.map((item, index) => {
        const { text } = item

        if ("icon" in item) {
            const {
                icon: { component: Icon, ...iconProps },
            } = item

            return {
                key: index,
                icon: <Icon {...iconProps} />,
                content: <Typography textStyle="body1">{text}</Typography>,
            }
        }

        const { image } = item

        return {
            key: index,
            // eslint-disable-next-line jsx-a11y/alt-text
            icon: <Image {...image} />,
            content: <Typography textStyle="body1">{text}</Typography>,
        }
    })

    return iconGridItems.map(({ icon, content }, index) => (
        <Fragment key={index}>
            <GridItem>{icon}</GridItem>
            <GridItem>{content}</GridItem>
        </Fragment>
    ))
}
